module.exports = __webpack_public_path__ + "img/pKlOe7dvjpt8A8SQ3B1wegYgewHm2fAc.b18b2d80.png";